export class DateRangeFromTo {
    public fromDate: any = new Date;
    public toDate: any = new Date;
}